import "./Episode.css";
import "../Student/Student.css";

import React, { Component } from "react";

import Constants from "../../../../Phi/Constants";
import FormComponent from '../../FormComponent'
import HSGTabs from "../../../HSGTabs";
import Source from "./Source";
import Validator from "dataphi-react-components/dist/Containers/FormScreen/FormComponent/Validator";

const formMetaDataList = [
    "med_height",
    "med_weight",
    "med_bp_sys",
    "med_bp_dia",
    "med_heart_rate",
    "med_body_temp",
    "med_respiratory_rate"
];
const minMaxValidations = ["med_bp_sys", "med_bp_dia", "med_heart_rate", "med_respiratory_rate"];

const vitalMetaMap = {
    med_bp_sys: 4,
    med_bp_dia: 5,
    med_respiratory_rate: 6,
    med_heart_rate: 7
};

const episodeKeys = {
    EPISODE: 'episode',
    ANTHROPOMETRIC: 'anthropometric',
    VITALS: 'vitals',
    EYE: 'optometry'
} 

const formMetaDataSerial = {
    ...Source.formDefs.metaData.reduce(
        (accumulator, field, index) =>
            formMetaDataList.includes(field.name) ? { ...accumulator, [field.name]: index } : { ...accumulator },
        {}
    )
};

class EpisodeForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialFetch: true,
            initialValidations: true,

            formDefEpisode: Source.formDefEpisode,
            formDefAnthropometric: Source.formDefAnthropometric,
            formDefVitals: Source.formDefVitals,
            formDefEye: Source.formDefEye,

            attachedSource: [],
            attachedKeys:[],
            activeForm: null,
            activeTab: "",
            formType:'',
            truncateForm: true,
            addedForm:false
        };
    }

    componentWillMount() {
        this.setState({ activeForm: this.state.formDefEpisode, activeTab: episodeKeys.EPISODE });
    }

    componentWillReceiveProps(newProps) {}

    getFormData = (data, form) => {
        let final = {}
        form.forEach(element => {
            if (data[element.name]) {
                final = Object.assign(final, {[element.name]: typeof(data[element.name]) === 'object' ? data[element.name].value : data[element.name]})
            }
        })

        return Object.keys(final).length > 0 ? final : null
    }

    saveEpisode = (data, parentId) => {
        let { activeTab } = this.state
        if(Boolean(data)) {
            if(Object.keys(data).length<=1) {
                return
            }
        }
        
        
        // if(!!!data || activeTab !== episodeKeys.EPISODE) {
        //     return
        // }

        let episode = Object.assign({}, data);

        episode.episode_parent_id = parentId;
        episode.episode_id = parentId;
        episode.med_created = new Date();
        episode.med_modified = new Date();

        episode.med_called_parents = episode.med_called && episode.med_called.includes("parent") ? true : null;
        episode.med_called_ambulance = episode.med_called && episode.med_called.includes("ambulance") ? true : null;

        delete episode.med_called;
        this.props.postEpisode(episode, Constants.episodeIdMap.EPISODE);
    }

    saveAnthropometric = (data, parentId) => {
        let { attachedKeys, activeTab } = this.state
        if(Boolean(data)) {
            var condition = Object.keys(data).map((d) => {return d !== 'med_height'})
            if(condition.every(v => v === true)) {
            if(Object.keys(data) !== 'med_height' && Object.keys(data).length <= 2) {
            return
        }}
    }
        // if(obje)

        if(!!!data) {
            return
        }
        
        // if(!!!data || (activeTab === episodeKeys.EPISODE || !!!attachedKeys.includes(episodeKeys.ANTHROPOMETRIC))) {
        //     return
        // }

        let episode = Object.assign({}, data);
        let timestamp =  new Date().getTime();
        let episodeId = this.state.activeTab === episodeKeys.EPISODE ? timestamp + '' + Constants.episodeIdMap.ANTHROPOMETRIC : parentId
        episode.episode_parent_id = parentId;
        episode.episode_id = episodeId;
        episode.med_created = new Date();
        episode.med_modified = new Date();
        
        this.props.postEpisode(episode, Constants.episodeIdMap.ANTHROPOMETRIC);
    }    

    saveVitals = (data, parentId, unit) => {
        let { attachedKeys, activeTab } = this.state
        if(Boolean(data)) {
                let new_data = {...data}
                delete new_data['med_in_time']
                delete new_data['med_out_time']
                if(Object.keys(new_data).length==0)
                {
                    return
                }
        }
    
        if(!!!data) {
            return
        }

        // if(!!!data || activeTab !== episodeKeys.VITALS || !!!attachedKeys.includes(episodeKeys.VITALS)) {
        //     return
        // }
        // if(Object.keys(data) === 'med_in_time' && Object.keys(data).length <= 2) {
        //     return
        // }

        
        if(!!!data) {
            return
        }

        let episode = Object.assign({}, data);
        let timestamp =  new Date().getTime();
        let episodeId = this.state.activeTab === episodeKeys.EPISODE ? timestamp + '' + Constants.episodeIdMap.VITALS : parentId
        episode.episode_parent_id = parentId;
        episode.episode_id = episodeId;
        episode.med_created = new Date();
        episode.med_modified = new Date();
        episode.med_body_temp_unit = unit ? unit : '°C';
        
        this.props.postEpisode(episode, Constants.episodeIdMap.VITALS);
    }    
    
    saveEye = (data, parentId) => {
        let { attachedKeys, activeTab } = this.state
    //     if(Boolean(data)) {
    //     if(Object.keys(data) !== 'optometryLeft' && Object.keys(data).length <= 2) {
    //         return
    //     }

    // }

    if(Boolean(data)) {
        var condition = Object.keys(data).map((d) => {return d !== 'optometryLeft'})
        if(condition.every(v => v === true)) {
        if(Object.keys(data) !== 'optometryLeft' && Object.keys(data).length <= 2) {
        return
    }}
}

        if(!!!data) {
            return
        }
        // if(!!!data || activeTab !== episodeKeys.EYE || !!!attachedKeys.includes(episodeKeys.EYE)) {
        //     return
        // }

        let episode = Object.assign({}, data);
        let timestamp =  new Date().getTime();
        let episodeId = this.state.activeTab === episodeKeys.EPISODE ? timestamp + '' + Constants.episodeIdMap.EYE : parentId
        episode.episode_parent_id = parentId;
        episode.episode_id = episodeId;
        episode.med_created = new Date();
        episode.med_modified = new Date();
        
        this.props.postEpisode(episode, Constants.episodeIdMap.EYE);
    }    

    getEyeData = (data) => {
        if (!!!data) {
            return
        }


    }

    handelSubmit = data => {
        console.log(data)
        let parentId = new Date().getTime();

        let defEpisode = Source.formDefEpisode
        let defAnthropometric = Source.formDefAnthropometric
        let defVitals = Source.formDefVitals
        let defEye = Source.formDefEye
        if(this.state.activeTab === 'episode'){
            this.saveEpisode(this.getFormData(data, defEpisode), parentId)
            this.saveAnthropometric(this.getFormData(data, defAnthropometric), parentId)
            this.saveVitals(this.getFormData(data, defVitals), parentId, data.med_body_temp_unit)
            this.saveEye(this.getFormData(data, defEye), parentId)
        }

        if(this.state.activeTab === 'anthropometric'){
            this.saveAnthropometric(this.getFormData(data, defAnthropometric), parentId)
        }

        if(this.state.activeTab === 'vitals'){
            this.saveVitals(this.getFormData(data, defVitals), parentId, data.med_body_temp_unit)
        }
        if(this.state.activeTab === 'optometry'){
            this.saveEye(this.getFormData(data, defEye), parentId)
        }
        
        this.props.closeEpisodeForm();
    };

    getFieldIndex = (form, key) => {
        for(let x=0; x<=form.length; x++){
            if(form[x].name === key){
                return x
            }
        }
        return null
    }

    handelBlur = input => {
        // debugger;
        // if(input.name === "med_bp_sys") {
        //     let key = this.getFieldIndex(this.state.activeForm, 'med_bp_dia')

        //     let activeForm = this.state.activeForm
        //     activeForm[key].validation = Boolean(input.value) ? [Validator.required]: []
        //     this.setState({
        //         activeForm: activeForm
        //     })
        // }
        // if(input.name === "med_bp_dia") {
        //     let key = this.getFieldIndex(this.state.activeForm, 'med_bp_sys')

        //     let activeForm = this.state.activeForm
        //     activeForm[key].validation = Boolean(input.value) ? [Validator.required]: []
        //     this.setState({
        //         activeForm: activeForm
        //     })
        // }
    };

    getMinMaxForAge = (meta, type, age) => {
        let mm;
        meta.forEach(element => {
            if (element.category === type) {
                if (element.metadata && element.metadata.age_min <= age && element.metadata.age_max >= age) {
                    mm = {
                        min: element.metadata.value_min,
                        max: element.metadata.value_max
                    };
                }
            }
        });

        return mm || {};
    };

    addVitalValidations = () => {
        this.setState({ initialValidations: false });
        let vitals = this.props.metaData.metaVitals;
        let age = this.props.age;
        minMaxValidations.forEach(element => {
            let mm = this.getMinMaxForAge(vitals, vitalMetaMap[element], age);
            Source.formDefs.metaData[formMetaDataSerial[element]].validation.push(Source.minValue(mm.min));
            Source.formDefs.metaData[formMetaDataSerial[element]].validation.push(Source.maxValue(mm.max));
        });
    };

    getTabMap = () => [
        { key: episodeKeys.EPISODE, label: "Episode", source: this.state.formDefEpisode },
        { key: episodeKeys.ANTHROPOMETRIC, label: "Anthropometric", source: this.state.formDefAnthropometric },
        { key: episodeKeys.VITALS, label: "Vitals", source: this.state.formDefVitals },
        { key: episodeKeys.EYE, label: "Optometry", source: this.state.formDefEye }
    ];

    addNewForm = (tab) => {
        let { attachedKeys, attachedSource } = this.state;
        let sourceCopy = [...tab.source];
        sourceCopy.pop();
        sourceCopy.pop();
        attachedKeys.push(tab.key)
        this.setState({attachedSource: attachedSource.concat(sourceCopy), attachedKeys})
        this.setState({
            addedForm:true
        })
    }

    removeNewForm = (tab) => {
        let { attachedKeys, attachedSource } = this.state
        let updatedAttachedKeys = attachedKeys.filter(selectedTab => {
            return selectedTab !== tab.key;
        })

        let updatedAttachedSource = attachedSource.filter((selectdSource,index) => {
            return !tab.source.includes(selectdSource)
        })
        this.setState({attachedKeys: updatedAttachedKeys, attachedSource: updatedAttachedSource});
        this.setState({
            formType: tab.key,
            addedForm:false
        })


    }

    loadMoreComponents = () => {

        let tabs = this.getTabMap()

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ textAlign: "center", marginTop: 20, marginBottom: 20 }}>
                {
                    tabs.map((tab, index) => (
                        tab.key !== episodeKeys.EPISODE  && 
                        <div 
                            key={index}
                            className="btn hsg-btn-white-episode"
                            style={{ margin: 10, width: 190 }}
                            onClick={ this.state.attachedKeys.includes(tab.key) ? ()=> this.removeNewForm(tab) : ()=> this.addNewForm(tab)}
                        >
                            {this.state.attachedKeys.includes(tab.key) ? <span className="icon-close red" style={{padding:5}} />  : <span className="icon-add blue" style={{padding:5}} />}
                            <text style={{padding:5}}>{tab.label}</text>
                        </div>
                    ))
                }
            </div>
        )
    };

    loadDynamicField = field => {
        let formGrp = {
            loadMoreComponents: this.loadMoreComponents()
        };
        return formGrp[field];
    };

    changeTab = index => {
        let tabs = this.getTabMap()[index];
        this.setState({
            activeTab: tabs.key,
            activeForm: tabs.source,
            attachedKeys: [],
            attachedSource: []
        });

        // this.props.clearForm()
        // this.props.initializeForm({})
        this.setState({truncateForm: !!!this.state.truncateForm})
    };

    generateForm = (activeForm, attachedSource) => {
        let dynamicField = {
            loadMoreComponents: () => this.loadDynamicField("loadMoreComponents")
        };

        let buttons = Source.formDefButtons;
        let form = activeForm;

        form = form.slice(0, -1).concat(attachedSource).concat(form.slice(-1));
        // form = form.concat(attachedSource);

        let metaData = form.map(dataItem => {
            if (dataItem.type === 'wildcard') {
                if(this.state.attachedKeys.includes(dataItem.name)) {
                    return dataItem
                }else {
                    return Object.assign({}, dataItem, {component: <div></div>, hide: true})
                }
            }else if(!!dynamicField[dataItem.type]) {
                const component = dynamicField[dataItem.type]();
                return {
                    name: dataItem.name,
                    type: "wildcard",
                    component
                };
            } else {
                return dataItem;
            }
        });

        return { ...buttons, metaData };
    };

    render() {
        // this.state.initialValidations && this.addVitalValidations()

        let { attachedSource, activeForm, activeTab } = this.state;

        let formDefs = this.generateForm(activeForm, attachedSource);
        return (
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <HSGTabs
                        className="col-lg-12 col-md-12 col-sm-12 col-xs-12 hsg-dashboard-add-school-btn"
                        selected={activeTab}
                        changeTab={this.changeTab}
                    >
                        {this.getTabMap().map((tab, i) => (
                            <div key={i} nav={tab.key} label={tab.label} badge={tab.badge}></div>
                        ))}
                    </HSGTabs>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ marginTop: 10 }}>
                    <FormComponent
                        truncateForm={this.state.truncateForm}
                        formDefs={formDefs}
                        onSubmit={data => this.handelSubmit(data)}
                        onClose={() => this.props.toggleModal(false)}
                        onFieldBlur={input => this.handelBlur(input)}
                        formType = {this.state.formType}
                        addedForm = {this.state.addedForm}
                    />
                </div>
            </div>
        );
    }
}

export default EpisodeForm;



// WEBPACK FOOTER //
// ./src/Containers/SmartClinicContainerV2/Component/Episode/EpisodeForm.js